<template>
  <div class="home-reasons wrap">
    <h2>Price</h2>
    <p class="sub-title">制作料金</p>

        <p>
         求人専用サイトの制作料金は77万円(税込)～です。求人詳細ページとして既存のホームページに埋め込む場合は、44万円(税込)～です。制作するホームページの内容によって異なります。基本的には、「制作工数＝料金」となるため、掲載する職種数が多い、デザインにこだわる、図解などの作図が多い、ヒアリングに要する工数など、手間がかかるほど料金は比例して高くなります。このように初期投資は必要になりますが、「クライアントのご指定の予算内で提案する」というスタンスのため、予算オーバーになることはございません。投じた料金は、人の採用によって結果から回収することができます。また、自社の求人サイト・求人ページは、一度作ればずっと使えます。有料掲載を止めたら終了という従来の求人媒体と違い、資産性があります。<span class="kome">※制作料とは別途で保守費用が発生します</span>
        </p>
        <!-- <p class="title">制作料金の実績</p>
        <img alt="制作料金の実績pc" src="@/assets/syukyaku-top-g001.png" class="pc-only"/>
        <img alt="制作料金の実績sp" src="@/assets/syukyaku-top-g001sp.png"  class="sp-only"/>
<p class="note">※別途、保守料がかかります</p> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default{
  name: "Home-any-concerns-or-problems",
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["rootUrl"]),
  },
};
</script>

<style lang="scss" scoped>
.title{
  font-size: 20px;
  color: var(--main);
  margin: 50px 0 10px 0;
}
.note{
  text-align: right;
}
</style>
